var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.367,
    height: 10.141,
    viewBox: "0 0 14.367 10.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "truck",
    d: "M3.02,5H11.3a.423.423,0,0,1,.423.423v.845h2.408A.592.592,0,0,1,14.7,6.7l.724,2.535a.423.423,0,0,1,.226.117l.6.6a.423.423,0,0,1,.124.3v2.783a.423.423,0,0,1-.423.423H14.676a1.69,1.69,0,0,1-3.38,0H7.071a1.69,1.69,0,0,1-3.38,0H2.423A.423.423,0,0,1,2,13.028V6.02a.423.423,0,0,1,.124-.3l.6-.6A.423.423,0,0,1,3.02,5ZM14.539,9.226l-.6-2.113H11.719V8.8a.423.423,0,0,0,.423.423Zm-1.553,3.38a.845.845,0,1,1-.845.845.845.845,0,0,1,.845-.845Zm-8.451.845a.845.845,0,1,0,.845-.845A.845.845,0,0,0,4.535,13.451Z",
    transform: "translate(-2 -5)",
    fill: "#63849c",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.49d9aa3a44bb76a8035e420be1e0cad5.svg";
export { ForwardRef as ReactComponent };